import * as React from "react";
import {
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType,
  PrimaryButton,
  Stack
} from "office-ui-fabric-react";
import { dateStringToMoment } from "../../utils/DateUtils";

export interface EulaDialogProps {
    eulaHtml: string;
    lastModified: string;
    onClose: (accept: boolean) => void;
}

interface EulaDialogState {
    showEula: boolean;
}

class EulaDialog extends React.Component<EulaDialogProps, EulaDialogState> {
    state = {
        showEula: false
    };
    
    toggleEulaVisibility = () => {
        this.setState(prevState => ({ showEula: !prevState.showEula }));
    };

    render() {
        const formattedDate = dateStringToMoment(this.props.lastModified).format('DD.MM.YYYY');
        return (
            <Dialog
                hidden={false}
                onDismiss={() => this.props.onClose(false)}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: "Turnitin lisensavtale for sluttbrukere",
                    subText: "Zokrates bruker Turnitin sin plagiatkontroll, og ved å fortsette godkjenner du deres betingelser"
                }}
                styles={{
                    main: [
                    {
                        selectors: {
                        ["@media (min-width: 480px)"]: {
                            maxWidth: "800px",
                            minWidth: "480px",
                            maxHeight: "800px"
                        }
                        }
                    }
                    ]
                }}
                modalProps={{
                    titleAriaId: "myLabelId",
                    subtitleAriaId: "mySubTextId",
                    isBlocking: true,
                    containerClassName: "ms-dialogMainOverride"
                }}
                >
                <Stack tokens={{ childrenGap: 20 }}>
                    <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 10 }}>
                        <DefaultButton
                            onClick={this.toggleEulaVisibility}
                            text={this.state.showEula ? "Skjul betingelser" : "Vis betingelser"}
                        />
                        <div>
                            Sist endret: {formattedDate}
                        </div>
                    </Stack>
                    {this.state.showEula && (
                        <div>
                            {this.props.eulaHtml ?
                                <div style={{height: 400, overflowY: "scroll"}} dangerouslySetInnerHTML={{ __html: this.props.eulaHtml.split('<body>')[1].split('</body>')[0] }} />
                            :
                                <div>Feil ved henting av lisensavtale</div>
                            }
                        </div>
                    )}
                </Stack>
                <DialogFooter>
                    <PrimaryButton
                        onClick={() => {
                            this.props.onClose(true);
                        }}
                        text="Fortsett"
                    />
                    <DefaultButton
                        onClick={() => {
                            this.props.onClose(false);
                        }}
                        text="Avbryt"
                    />
                </DialogFooter>
            </Dialog>
        );
    }
}

export default EulaDialog;